import { toast } from "react-toastify";
import { apiSlice } from './../../../api/apiSlice';


export const milestoneApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMilestones: builder.query({
      query: () => ({
        url: `milestone?query=all`,
      }),
      providesTags: ["Milestones"],
    }),

    getMilestoneByProjectId: builder.query({
      query: (id) => ({
        url: `milestone/${id}/project`,
      }),
      providesTags: ["MilestoneById"],
    }),

    getMilestone: builder.query({
      query: (id) => ({
        url: `milestone/${id}`,
      }),
      providesTags: ["Milestone"],
    }),

    addMilestone: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `milestone/`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Milestones added successfully");
        } catch (err) {
          toast.error("An error occurred while adding Milestones");
        }
      },
      invalidatesTags: ["Milestones", "MilestoneById", "Milestone"],
    }),

    updateMilestone: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `milestone/${id}?query=all`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Milestones updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Milestones");
        }
      },
      invalidatesTags: ["Milestones", "MilestoneById", "Milestone"],
    }),

    updateMilestoneStatus: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `milestone/${id}/status`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Milestones Status updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Milestones Status");
        }
      },
      invalidatesTags: ["Milestones", "MilestoneById", "Milestone"],
    }),

    deleteMilestone: builder.mutation({
      query: (id) => ({
        url: `milestone/${id}`,
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: false,
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Deleted Milestones successful");
        } catch (err) {
          toast.error("An error occurred while deleting the Milestones");
        }
      },
      invalidatesTags: ["Milestones", "MilestoneById", "Milestone"],
    }),
  }),
});

export const {
  useGetMilestonesQuery,
  useGetMilestoneByProjectIdQuery,
  useGetMilestoneQuery,
  useAddMilestoneMutation,
  useUpdateMilestoneMutation,
  useUpdateMilestoneStatusMutation,
  useDeleteMilestoneMutation,
} = milestoneApi;
